<template>
  <div class="main-page">
    <section class="page-section">
      <div class="container">
        <div class="grid">
          <div class="col comp-grid">
            <div class="">
              <div>
                <div class="relative-position" style="min-height: 100px">
                  <template v-if="!loading && item">
                    <div class="row q-col-gutter-x-md">
                      <div class="text-2xl text-primary font-bold">
                        {{ item.caps_programmes_list_programme_title }}
                      </div>
                      <div class="my-3 text-gray-500">
                        {{ item.institution_schools_name }}
                      </div>
                      <div class="my-3 text-500 text-sm mb-1">
                        {{ $t("cut_off_point") }}:
                        <span class="font-bold">{{ item.cut_off_point }}</span>
                      </div>

                      <div class="col-12">
                        <div
                          v-if="item.programme_description"
                          class="grid align-items-center"
                        >
                          <Divider />
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("programme_description") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.programme_description }}
                            </div>
                          </div>
                        </div>
                        <!-- <div
                          v-if="item.programme_options"
                          class="grid align-items-center"
                        >
                          <Divider />
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("programme_options") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.programme_options }}
                            </div>
                          </div>
                        </div> -->
                        <div
                          v-if="item.programme_sessions"
                          class="grid align-items-center"
                        >
                          <Divider />
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("available_sessions") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.programme_sessions }}
                            </div>
                          </div>
                        </div>
                        <div
                          v-if="item.programme_required_electives"
                          class="grid align-items-center"
                        >
                          <Divider />
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("required_electives") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.programme_required_electives }}
                            </div>
                          </div>
                        </div>
                        <div
                          v-if="item.programme_campuses"
                          class="grid align-items-center"
                        >
                          <Divider />
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              {{ $t("programme_campuses") }}:
                            </div>
                            <div class="font-bold">
                              {{ item.programme_campuses }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-if="loading">
                    <div class="p-3 text-center">
                      <ProgressSpinner style="width: 50px; height: 50px" />
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { defineAsyncComponent, ref } from "vue";
import { PageMixin } from "../../mixins/page.js";
import { ViewPageMixin } from "../../mixins/viewpage.js";
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  name: "viewInstitutionprogrammesPage",
  components: {},
  mixins: [PageMixin, ViewPageMixin],
  props: {
    pageName: {
      type: String,
      default: "institution_programmes",
    },
    idName: {
      type: String,
      default: "institution_programme_id",
    },
    routeName: {
      type: String,
      default: "programmesrecordview",
    },
    pagePath: {
      type: String,
      default: "custom/programmes_record_view",
    },
    apiPath: {
      type: String,
      default: "institution_programmes/view",
    },
  },
  data() {
    return {
      item: {
        default: {},
      },
    };
  },
  computed: {
    pageTitle: {
      get: function () {
        return "Programme Details";
      },
    },
    currentRecord: {
      get: function () {
        return this.$store.getters["institution_programmes/currentRecord"];
      },
      set: function (value) {
        this.$store.commit("institution_programmes/setCurrentRecord", value);
      },
    },
  },
  meta() {
    return {
      title: this.pageTitle,
    };
  },
  methods: {
    ...mapActions("institution_programmes", ["fetchRecord"]),
  },
  watch: {
    $route(to, from) {
      //only fetch data when navigated to this page
      if (to.name == this.routeName) {
        //this.load();
      }
    },
  },
  async mounted() {},
  async created() {},
};
</script>
<style scoped></style>
